import {
	default as EChartsReact,
	default as ReactECharts,
} from "echarts-for-react";
import React, { Component } from "react";
import { ENROLLMENT_DISTRIBUTION } from "../../../api/types";
// interface data {
// 	value: number;
// 	name: string;
// }
interface AppProp {
	value: Array<any>;
	topic: boolean;
	onDownload: (urls: [string, string]) => void;
}
const displayRealm = [
	"Elixir Institute",
	"Pythagoras Peninsula",
	"Fahren Heights",
	"Prehistoric Point",
	"Green Acres",
	"Habiterra",
	"DNAtion",
	"Cape Cosmos",
	"Edison Avenue",
	"E=MC Square",
];
const displayTopic = [
	"Medicine & Health",
	"Mathematics",
	"Weather",
	"Dinosaurs & Fossils",
	"Environment & Nature",
	"Animals",
	"Life & Evolution",
	"Space",
	"Inventions",
	"Physics",
];
export class EnrollmentDistribution extends Component<AppProp, {}> {
	// getData(dict: Array<any>): Array<any> {
	// 	// eslint-disable-next-line @typescript-eslint/no-array-constructor
	// 	const output = new Array();
	// 	for (const item of dict) {
	// 		const key = Object.keys(item);
	// 		for (const i of key) {
	// 			const newLine = { value: item[i], name: i } as data;
	// 			output.push(newLine);
	// 		}
	// 	}
	// 	const result = Object.values(
	// 		output.reduce((acc, { name, value }) => {
	// 			// eslint-disable-next-line @typescript-eslint/restrict-plus-operands
	// 			acc[name] = { name, value: (acc[name] ? acc[name].value : 0) + value };
	// 			// eslint-disable-next-line @typescript-eslint/no-unsafe-return
	// 			return acc;
	// 		}, {}),
	// 	);

	// 	// eslint-disable-next-line @typescript-eslint/no-unsafe-return
	// 	return result;
	// }

	private echartsRef: React.RefObject<EChartsReact>;

	private onDownload: (urls: [string, string]) => void;

	constructor(props: AppProp) {
		super(props);
		this.echartsRef = React.createRef();
		this.onDownload = props.onDownload;
		this.state = { imgUrl: "" };
	}

	componentDidUpdate(
		_prevProps: Readonly<AppProp>,
		prevState: { imgUrl: string },
	): void {
		// @ts-ignore
		const base64: string = this.echartsRef.current
			.getEchartsInstance()
			.getDataURL();
		if (prevState.imgUrl !== base64) {
			this.setState({ imgUrl: base64 });
			this.onDownload([ENROLLMENT_DISTRIBUTION, base64]);
		}
	}

	getData(name: string, dict: Array<any>): number {
		const output: number[] = [];
		for (const item of dict) {
			if (name in item) {
				output.push(item[name]);
			} else {
				output.push(0);
			}
		}
		let sum = 0;
		if (output && output.length) {
			sum = output.reduce(
				(accumulator, currentValue) => accumulator + currentValue,
			);
		}
		return sum;
	}

	getOption(activity: Array<any>): Object {
		return {
			title: {
				text: "Enrollment Distribution",
				left: "center",
			},
			tooltip: {
				trigger: "item",
				formatter: "{a} <br/>{b}: {c} ({d}%)",
			},
			series: [
				{
					name: this.props.topic ? "Topic:" : "Realm:",
					type: "pie",
					radius: "70%",
					// data: this.getData(activity),
					data: [
						{
							value:
								this.getData(displayRealm[0]!, activity) === 0
									? null
									: this.getData(displayRealm[0]!, activity),
							name: this.props.topic ? displayTopic[0]! : displayRealm[0]!,
							itemStyle: { color: "#DD4E42" },
						},
						{
							value:
								this.getData(displayRealm[1]!, activity) === 0
									? null
									: this.getData(displayRealm[1]!, activity),
							name: this.props.topic ? displayTopic[1]! : displayRealm[1]!,
							itemStyle: { color: "#F18458" },
						},
						{
							value:
								this.getData(displayRealm[2]!, activity) === 0
									? null
									: this.getData(displayRealm[2]!, activity),
							name: this.props.topic ? displayTopic[2]! : displayRealm[2]!,
							itemStyle: { color: "#F1D25B" },
						},
						{
							value:
								this.getData(displayRealm[3]!, activity) === 0
									? null
									: this.getData(displayRealm[3]!, activity),
							name: this.props.topic ? displayTopic[3]! : displayRealm[3]!,
							itemStyle: { color: "#D2C39F" },
						},
						{
							value:
								this.getData(displayRealm[4]!, activity) === 0
									? null
									: this.getData(displayRealm[4]!, activity),
							name: this.props.topic ? displayTopic[4]! : displayRealm[4]!,
							itemStyle: { color: "#8FC181" },
						},
						{
							value:
								this.getData(displayRealm[5]!, activity) === 0
									? null
									: this.getData(displayRealm[5]!, activity),
							name: this.props.topic ? displayTopic[5]! : displayRealm[5]!,
							itemStyle: { color: "#73DCCD" },
						},
						{
							value:
								this.getData(displayRealm[6]!, activity) === 0
									? null
									: this.getData(displayRealm[6]!, activity),
							name: this.props.topic ? displayTopic[6]! : displayRealm[6]!,
							itemStyle: { color: "#CEE7F5" },
						},
						{
							value:
								this.getData(displayRealm[7]!, activity) === 0
									? null
									: this.getData(displayRealm[7]!, activity),
							name: this.props.topic ? displayTopic[7]! : displayRealm[7]!,
							itemStyle: { color: "#6272D1" },
						},
						{
							value:
								this.getData(displayRealm[8]!, activity) === 0
									? null
									: this.getData(displayRealm[8]!, activity),
							name: this.props.topic ? displayTopic[8]! : displayRealm[8]!,
							itemStyle: { color: "#8B5AA3" },
						},
						{
							value:
								this.getData(displayRealm[9]!, activity) === 0
									? null
									: this.getData(displayRealm[9]!, activity),
							name: this.props.topic ? displayTopic[9]! : displayRealm[9]!,
							itemStyle: { color: "#FCC2D7" },
						},
					],
					emphasis: {
						itemStyle: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: "rgba(0, 0, 0, 0.5)",
						},
					},
				},
			],
		};
	}

	render(): JSX.Element {
		return (
			<ReactECharts
				ref={this.echartsRef}
				option={this.getOption(this.props.value)}
				// style={{height: '250px', width: '500px'}}
			/>
		);
	}
}
